import React, { Fragment, useState, useEffect } from "react"
import { Button, Col, Container, Form, Row, Table } from "react-bootstrap"
import { useNavigate, useParams } from "react-router-dom"
import Navbar from "../../../../Components/Navbar/Navbar"
import trash from "./../../../../Assets/Images/trash.png"
import Modal from "antd/es/modal/Modal"
import Select from "react-select"
import { Select as SearchBox } from "antd"
import "../../PurchaseOrders/PurchaseOrders.css"
import "../PaySuppliers.css"
import {
  antdesignSelectStyle,
  formatDateNoTime,
} from "../../../../Helpers/Utils/Common"
import {
  getAllSuppliers,
  createSupplier,
  searchSupplier,
} from "../../../../Helpers/apiCalls/suppliersApi"
import {
  numberFormat,
  refreshPage,
  TokenExpiry,
  toastStyle,
} from "../../../../Helpers/Utils/Common"
import { createBank } from "../../../../Helpers/apiCalls/Manage/Banks"
import { getAllCheckTemplates } from "../../../../Helpers/apiCalls/Manage/CheckTemplates"
import { validateBanks } from "../../../../Helpers/Validation/Manage/BanksValidation"
import ReactLoading from "react-loading"
import { getAllBanks } from "../../../../Helpers/apiCalls/banksAPi"
import {
  validatePaymentListCash,
  validatePaymentListCheck,
  validatePaymentListBank,
  validatePaymentListOthers,
} from "../../../../Helpers/Validation/Supplies/PaymentListValidation"
import InputError from "../../../../Components/InputError/InputError"
import {
  createSeBankPayment,
  createSeCashPayment,
  createSeCheckPayment,
  createSeOtherPayment,
  getSingleBankSe,
  getSingleCashSe,
  getSingleCheckSe,
  getSingleOtherSe,
  updateBankPayment,
  updateCashPayment,
  updateCheckPayment,
  updateOtherPayment,
} from "../../../../Helpers/apiCalls/Expenses/sePaymentsListApi"
import toast from "react-hot-toast"
import {
  getSingleSeReceive,
  getOpenSeReceives,
} from "../../../../Helpers/apiCalls/receiveApi"
import AddModal from "../../../../Components/Modals/AddModal"
import Moment from "moment"
import { getAllEmployees } from "../../../../Helpers/apiCalls/employeesApi"
import FileExceedModal from "../../../../Components/Modals/FileExceedModal"
import Compressor from "compressorjs"
import noDataImg from "../../../../Assets/Images/no-data-img.png"
import Upload from "antd/es/upload/Upload"
import upload from "../../../../Assets/Images/upload.png"
import Footer from "../../../../Components/Footer/Footer"

function FormPaySupplier({ add, edit }) {
  const { Dragger } = Upload
  const { id, type } = useParams()
  let navigate = useNavigate()
  const [isClicked, setIsClicked] = useState(false)
  const [selectedEntry, setSelectedEntry] = useState("")
  const [inactive, setInactive] = useState(true)
  const [transactionFee, setTransactionFee] = useState("0")
  const [grandTotal, setGrandTotal] = useState(0)
  const [totalAmount, setTotalAmount] = useState(0)
  const [totalWthTax, setTotalWthTax] = useState(0)
  const [supplierTaxPercentage, setSupplierTaxPercentage] = useState(0)
  const [employees, setEmployees] = useState([])
  const [isChanged, setIsChanged] = useState(false)
  const [preview, setPreview] = useState(false)
  const [previewFile, setPreviewFile] = useState("")
  const [prevAttachments, setPrevAttachments] = useState([])
  const [showFileExceedModal, setShowFileExceedModal] = useState(false)
  const [fileList, setFileList] = useState([])
  const [suppliers, setSuppliers] = useState([])
  const [banks, setBanks] = useState([])
  const [fromBanks, setFromBanks] = useState([])
  const [selectedOptions, setSelectedOptions] = useState([])

  async function fetchEmployees() {
    setEmployees([])
    const response = await getAllEmployees()
    if (response.data) {
      const result = response.data.data.map((data) => {
        var _middleName = data.middle_name || ""
        return {
          value: data.id,
          label: data.first_name + " " + _middleName + " " + data.last_name,
          name: "acknowledged_by",
        }
      })
      setEmployees(result)
    }
  }

  const [newPayment, setNewPayment] = useState({
    supplier_id: "",
    grand_total: 0,
    payment_date: "",
    check_date: "",
    issued_date: "",
    to_account_no: "",
    to_account_name: "",
    from_account_no: "",
    from_account_name: "",
  })
  const [checkTemplateData, setCheckTemplateData] = useState([])
  const [employeeValue, setEmployeeValue] = useState({
    name: "acknowledged_by",
    label: "",
    value: "",
  })
  const [fromBankValue, setFromBankValue] = useState({
    name: "bank_from",
    label: "",
    value: "",
  })

  if (
    (type === "cash" || type === "bank") &&
    (newPayment.payment_date === "") & add
  ) {
    setNewPayment({
      payment_date: Moment().format("YYYY-MM-DD"),
      issued_date: Moment().format("YYYY-MM-DD"),
    })
  }

  if (
    type === "check" &&
    newPayment.check_date === "" &&
    (newPayment.issued_date === "") & add
  ) {
    setNewPayment({
      check_date: Moment().format("YYYY-MM-DD"),
      issued_date: Moment().format("YYYY-MM-DD"),
    })
  }

  function handleTransactionFeeChange(e) {
    var value = e.target.value
    if (value === "") setTransactionFee("")
    else setTransactionFee(value)
    setNewPayment({ ...newPayment, transaction_fee: value })
  }

  const [items, setItems] = useState([])
  const [entries, setEntries] = useState([])
  const [entriesList, setEntriesList] = useState([])
  const [remove, setRemove] = useState("")

  //ERROR HANDLING
  const [isError, setIsError] = useState({
    payment_date: false,
    supplier_id: false,
    payee: false,
    acknowledged_by: false,
    list: false,
    listInfo: false,
  })

  const [isErrorCheck, setIsErrorCheck] = useState({
    supplier_id: false,
    bank_id: false,
    check_date: false,
    check_no: false,
    issued_date: false,
    payee: false,
    acknowledged_by: false,
    list: false,
    listInfo: false,
  })

  const [isErrorBank, setIsErrorBank] = useState({
    payment_date: false,
    bank_from: false,
    from_account_no: false,
    from_account_name: false,
    bank_to: false,
    to_account_no: false,
    to_account_name: false,
    reference_no: false,
    supplier_id: false,
    payee: false,
    acknowledged_by: false,
    list: false,
    listInfo: false,
  })

  //ERROR HANDLING
  const [isErrorAddBank, setIsErrorAddBank] = useState({
    bank_name: false,
    check_template_id: false,
    acknowledged_by: false,
  })

  // ADD
  const [showAddBankModal, setShowAddBankModal] = useState(false)
  const handleShowAddBankModal = () => setShowAddBankModal(true)
  const handleCloseAddBankModal = () => setShowAddBankModal(false)

  // INVOICE REMOVAL HANDLER
  function handleRemoveItem(e, id) {
    setIsChanged(true)
    // if (id === 0) {
    //   setSelectedEntry(id)
    // } else {
    //   setSelectedEntry(id - 1)
    // }
    // setRemove(e.target.value)
    // // const { name, label, value } = e;
    // const rowId = id
    // const newItemList = [...items]
    // newItemList.splice(rowId, 1)
    // setItems(newItemList)

    // var returnitem = entriesList.filter((data) => data.value === e.target.value)
    // var entriescopy = [...entries]

    // entriescopy.push(returnitem[0])

    // entriescopy.sort((a, b) => {
    //   return a.value - b.value
    // })

    // entriescopy?.filter((v, i) => {
    //   return entriescopy.map((val) => val.value).indexOf(v.value) == i
    // })

    // setEntries(entriescopy)
    // setTimeout(() => setIsChanged(false), 10)
    setSelectedEntry(id === 0 ? id : id - 1)
    const removedItem = items[id]
    const newItemList = [...items]
    newItemList.splice(id, 1)
    setItems(newItemList)
    setSelectedOptions((prevSelectedInvoices) =>
      prevSelectedInvoices.filter(
        (invoice) => invoice !== removedItem.entry.value
      )
    )
    if (selectedOptions.length === 0 && entries.length > 0) {
      // Check if the removed invoice already exists in the options list
      const isAlreadyInOptions = entries.some(
        (entry) => entry.value === removedItem.entry.value
      )

      // Add the removed invoice back to the options list if it's not already there
      if (!isAlreadyInOptions) {
        setEntries((prevEntries) => [...prevEntries, removedItem.entry])
      }
    }
  }

  function wthComputation(sales) {
    const wth_percentage = parseFloat(supplierTaxPercentage) / 100
    if (sales) {
      const vatableSales = parseFloat(sales) / 1.12
      return parseFloat(vatableSales * wth_percentage).toFixed(2)
    } else {
      return 0
    }
  }

  function AddItem() {
    const newItem = {
      entry: {
        name: "receive_id",
        label: "Select Invoice...",
        value: "",
      },
      se_ids: "",
      amount: 0,
      other_fees: 0,
      date: "",
      withholding: wthComputation(0),
    }
    setItems((prevItems) => [...prevItems, newItem])
  }

  const handleBeforeUpload = (file) => {
    if (file.size > 2000000) {
      setShowFileExceedModal(true)
    } else {
      //COMPRESSING FILE
      new Compressor(file, {
        quality: 0.6,
        success: (compressedResult) => {
          setFileList([...fileList, compressedResult])
        },
      })
    }
    return false
  }

  // TO REMOVE UPLOADED FILE
  const handleRemove = (selectedFile) => {
    var newlist = fileList.filter((file) => {
      return selectedFile.uid !== file.uid
    })
    setFileList(newlist)
  }

  function handleRemoveItemAttachment(url) {
    var newList = prevAttachments.filter((data) => {
      return data.file_url !== url
    })
    setPrevAttachments(newList)
    setPreview(false)
  }

  // INVOICE CHANGE HANDLER
  function handleItemChange(e, id) {
    setSelectedEntry(id)
    setIsChanged(true)
    const { name, label, value } = e

    if (name === "se_ids") {
      if (selectedEntry === id) {
        var entryData = entries.filter((entry) => {
          return entry.value === value
        })
        setEntries(entriesList.filter((data) => data.value != value))
      } else {
        var entryData = entries.filter((entry) => {
          return entry.value === value
        })
        setEntries(entries.filter((data) => data.value != value))
      }

      var newItemList = items
      var newEntries = newItemList.map((item, index) => {
        if (index === id) {
          var info = {
            name: name,
            label: label,
            value: value,
          }
          item.entry = info
          item.invoice_date = Moment(entryData[0].invoice_date).format(
            "MMM DD, YYYY"
          )
          item.amount = entryData[0].amount
          item.other_fees = entryData[0].other_fees
          item.withholding = entryData[0].withholding
          item.withholding_percentage = entryData[0].withholding_percentage
          item.vat_type = entryData[0].vat_type
          item.subtotal =
            parseFloat(entryData[0].amount) -
            parseFloat(entryData[0].withholding)
          item.grand_amount =
            parseFloat(entryData[0].amount) +
            parseFloat(entryData[0].other_fees) -
            parseFloat(entryData[0].withholding)
        }
        return item
      })
      setItems(newEntries)
    } else {
      const { name, value } = e.target
      const list = [...items]

      if (name === "amount") {
        items.map((item, index) => {
          if (index === id) {
            item[name] = value
            const wth_percentage = parseFloat(item.withholding_percentage) / 100
            if (item.vat_type === "VAT") {
              const vatableSales = parseFloat(item.amount) / 1.12
              item["withholding"] = parseFloat(
                vatableSales * wth_percentage
              ).toFixed(2)
            } else {
              item["withholding"] = 0
            }
            item["subtotal"] =
              parseFloat(item.amount) - parseFloat(item.withholding)
            item["grand_amount"] =
              parseFloat(item.amount) +
              parseFloat(item.other_fees) -
              parseFloat(item.withholding)
          }
        })
      } else if (name === "other_fees") {
        items.map((item, index) => {
          if (index === id) {
            item[name] = value
            item["subtotal"] =
              parseFloat(item.amount) - parseFloat(item.withholding)
            item["grand_amount"] =
              parseFloat(item.amount) +
              parseFloat(value) -
              parseFloat(item.withholding)
          }
        })
      } else {
        items.map((item, index) => {
          if (index === id) {
            item[name] = value
          }
        })
      }
      setItems(list)
    }
    setTimeout(() => setIsChanged(false), 10)
  }

  function handleInvoiceChange(e, id) {
    // setSelectedEntry(id)
    // setIsChanged(true)

    // const selectedValue = e
    // const entryData = entries.filter((entry) => entry.value === selectedValue)
    // const newItems = items.map((item, index) => {
    //   if (index === id) {
    //     const newItem = { ...item } // Copy the item object

    //     // Update item properties based on the selected entryData
    //     newItem.entry = {
    //       name: "entry",
    //       label: entryData[0]?.label,
    //       value: entryData[0]?.value,
    //     }

    //     // Update other item properties as needed based on entryData
    //     newItem.sales_invoice_id = entryData[0]?.id
    //     newItem.invoice_date = entryData[0]?.invoice_date
    //     newItem.amount = entryData[0]?.amount
    //     newItem.other_fees = entryData[0]?.other_fees
    //     newItem.withholding = entryData[0]?.withholding
    //     newItem.withholding_percentage = entryData[0]?.withholding_percentage
    //     newItem.vat_type = entryData[0]?.vat_type
    //     newItem.subtotal =
    //       parseFloat(entryData[0]?.amount) -
    //       parseFloat(entryData[0]?.withholding)
    //     newItem.grand_amount =
    //       parseFloat(entryData[0]?.amount) +
    //       parseFloat(entryData[0]?.other_fees) -
    //       parseFloat(entryData[0]?.withholding)

    //     return newItem
    //   }
    //   return item
    // })

    // // Update items state
    // setItems(newItems)

    // setTimeout(() => setIsChanged(false), 10)
    setSelectedEntry(id)
    setIsChanged(true)

    setSelectedOptions((prevSelectedInvoices) => [...prevSelectedInvoices, e])

    const selectedValue = e
    if (selectedEntry === id) {
      // Get the previous selection for this row
      if (selectedOptions[id] !== undefined) {
        // Get the previous selection for this row
        const previousSelection = selectedOptions[id]

        // Remove the most recent selection from selectedOptions
        setSelectedOptions((prevSelectedOptions) =>
          prevSelectedOptions.filter((option) => option !== previousSelection)
        )

        const isDuplicate = entries.some(
          (entry) => entry.value === previousSelection
        )

        // Put the previous selection back to the options list if it's not a duplicate
        if (!isDuplicate) {
          setEntries((prevEntries) => [...prevEntries, previousSelection])
        }
      }
    }

    const entryData = entries.filter((entry) => entry.value === selectedValue)
    const newItems = items.map((item, index) => {
      if (index === id) {
        const newItem = { ...item } // Copy the item object

        // Update item properties based on the selected entryData
        newItem.entry = {
          name: "entry",
          label: entryData[0]?.label,
          value: entryData[0]?.value,
        }

        // Update other item properties as needed based on entryData
        newItem.sales_invoice_id = entryData[0]?.id
        newItem.invoice_date = entryData[0]?.invoice_date
        newItem.amount = entryData[0]?.amount
        newItem.other_fees = entryData[0]?.other_fees
        newItem.withholding = entryData[0]?.withholding
        newItem.withholding_percentage = entryData[0]?.withholding_percentage
        newItem.vat_type = entryData[0]?.vat_type
        newItem.subtotal =
          parseFloat(entryData[0]?.amount) -
          parseFloat(entryData[0]?.withholding)
        newItem.grand_amount =
          parseFloat(entryData[0]?.amount) +
          parseFloat(entryData[0]?.other_fees) -
          parseFloat(entryData[0]?.withholding)

        return newItem
      }
      return item
    })

    // Update items state
    setItems(newItems)
    setTimeout(() => setIsChanged(false), 10)
  }

  const filteredOptions = entries.filter(
    (entry) => !selectedOptions.includes(entry.value)
  )

  const [supplierDetails, setSupplierDetails] = useState({
    trade_name: "",
    trade_address: "",
    bir_name: "",
    bir_address: "",
    tin: "",
    terms: "",
    requirements: "",
    phone_no: "",
    email: "",
    contact_person: "",
    bank_primary: "",
    bank_alternate: "",
    payee: "",
  })

  const [showAddSupplierModal, setShowAddSupplierModal] = useState(false)
  const handleShowAddSupplierModal = () => setShowAddSupplierModal(true)
  const handleCloseAddSupplierModal = () => {
    setShowAddSupplierModal(false)
  }

  function renderTable() {
    return (
      <Table>
        <thead>
          <tr>
            <th>Entry</th>
            <th>Invoice Date</th>
            <th>Invoice Details</th>
            <th>Amount</th>
            <th>Service Fee</th>
            <th>Withholding</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item, index) => {
            return (
              <tr key={index}>
                <td className="select-cont">
                  {/* <Select
                    className="text-start react-select-container"
                    classNamePrefix="react-select"
                    placeholder="Select Invoice..."
                    options={entries}
                    name="entry"
                    value={item.entry}
                    onChange={(e) => handleItemChange(e, index)}
                  /> */}
                  <SearchBox
                    value={item.entry}
                    placeholder={"Search Item..."}
                    className="react-select-container w-full"
                    dropdownClassName="z-large antdesign-custom-dropdown"
                    style={antdesignSelectStyle}
                    defaultActiveFirstOption={false}
                    suffixIcon={null}
                    filterOption={false}
                    options={(filteredOptions || []).map((d) => ({
                      value: d.value,
                      label: d.label,
                    }))}
                    onChange={(e) =>
                      handleInvoiceChange(e, index, "invoice_id")
                    }
                  />
                  <InputError
                    isValid={isError.listInfo}
                    message={"Invoice is required"}
                  />
                  <InputError
                    isValid={isErrorCheck.listInfo}
                    message={"Invoice is required"}
                  />
                  <InputError
                    isValid={isErrorBank.listInfo}
                    message={"Invoice is required"}
                  />
                </td>
                <td>{item.invoice_date ? item.invoice_date : ""}</td>
                <td>
                  <button
                    type="button"
                    className="button-primary view-btn me-3"
                    onClick={() => handleViewPayment(item.entry.value, 0, type)}
                  >
                    View
                  </button>
                </td>
                <td className="d-flex align-contents">
                  <Col>
                    <Form.Control
                      type="number"
                      name="amount"
                      className="hide-spinner mt-2"
                      value={item.amount}
                      onChange={(e) => handleItemChange(e, index)}
                    />
                    <InputError
                      isValid={isError.listInfo}
                      message={"Amount is required"}
                    />
                    <InputError
                      isValid={isErrorCheck.listInfo}
                      message={"Amount is required"}
                    />
                    <InputError
                      isValid={isErrorBank.listInfo}
                      message={"Invoice is required"}
                    />
                  </Col>
                </td>
                <td>
                  <Form.Control
                    type="number"
                    name="other_fees"
                    className="hide-spinner numeric-input"
                    value={item.other_fees}
                    onChange={(e) => handleItemChange(e, index)}
                  />
                </td>
                <td>
                  <Form.Control
                    type="number"
                    name="withholding"
                    className="hide-spinner numeric-input"
                    value={item.withholding}
                    onChange={(e) => handleItemChange(e, index)}
                    disabled
                  />
                </td>
                <td>
                  <img
                    src={trash}
                    alt="delete"
                    onClick={(e) => {
                      item.entry
                        ? handleRemoveItem(
                            {
                              target: {
                                value: item.entry.value,
                                name: "id",
                              },
                            },
                            index
                          )
                        : handleRemoveItem(e, index)
                    }}
                    className="cursor-pointer"
                  />
                </td>
              </tr>
            )
          })}
        </tbody>
      </Table>
    )
  }

  function handleViewPayment(id, bank, type) {
    window.open("/se/purchaseinvoices/print/" + id, "_blank")
  }

  const handleSearchSupplier = (newValue) => {
    if (newValue.length > 2) {
      //if length of the input is greater than 3, it will call the search api
      fetchSuppliers(newValue, setSuppliers)
    }
  }

  // new api for searching items
  async function fetchSuppliers(value, setSuppliers) {
    setSuppliers([])
    const response = await searchSupplier({ name: value })
    if (response.response) {
      var suppliers = response.response.data.map((data) => {
        var info = data
        info.label = data.trade_name
        info.value = data.id
        info.label = data.trade_name
        info.contact_person = data.contact_person
        info.phone_no = data.phone_no

        return info
      })
      setSuppliers(suppliers)
    } else {
      response.error?.data?.messages.map((data) => {
        return toast.error(data, {
          style: toastStyle(),
        })
      })
    }
  }
  async function fetchBanks() {
    const response = await getAllBanks()
    if (response.data) {
      var data = response.data.data
      var allBanks = data.map((bank) => {
        var info = {}
        info.name = "bank_id"
        info.label = bank.bank_name
        info.value = bank.id
        return info
      })
      setBanks(allBanks)

      var fromBanks = data.map((bank) => {
        var info = {}
        info.name = "bank_from"
        info.label = bank.bank_name
        info.value = bank.id
        return info
      })
      setFromBanks(fromBanks)
    }
  }

  const [supplierValue, setSupplierValue] = useState({
    name: "supplier_id",
    label: "",
    value: "",
    payee: "",
  })
  const [bankValue, setBankValue] = useState({
    name: "bank_id",
    label: "",
    value: "",
  })

  function handleSelectChange(e, type) {
    const newList = newPayment
    newList[e.name] = e.value
    setNewPayment(newList)

    if (type === "supplier_id") {
      setItems([])
      var supplier_name = suppliers.filter((data) => {
        return data.value === e
      })
      setNewPayment((prev) => {
        return {
          ...prev,
          supplier_id: e,
          payee: supplier_name[0].payee
            ? supplier_name[0].payee
            : newPayment.payee,
          supplier_id_value: {
            label: supplier_name[0].label,
            value: supplier_name[0].value,
          },
        }
      })

      fetchReceives({
        supplier_id: e,
      })
    } else {
      if (e.name === "bank_id") {
        setBankValue({ name: e.name, label: e.label, value: e.value })
      } else if (e.name === "bank_from") {
        setFromBankValue({ name: e.name, label: e.label, value: e.value })
        setNewPayment({
          ...newPayment,
          bank_from: e.value,
        })
      } else if (e.name === "bank_to") {
        // setToBankValue({ name: e.name, label: e.label, value: e.value });
        setNewPayment({
          ...newPayment,
          bank_to: e.value,
        })
      } else if (e.name === "acknowledged_by") {
        setEmployeeValue({ name: e.name, label: e.label, value: e.value })
        setNewPayment({
          ...newPayment,
          acknowledged_by: e.value,
        })
      }
    }
  }

  function handlePayChange(e) {
    const { name, value } = e.target
    setIsChanged(true)
    const newList = newPayment
    newList[name] = value
    setNewPayment(newList)
    setTimeout(() => setIsChanged(false), 10)
  }

  async function savePayment() {
    if (isClicked) {
      return
    }
    newPayment.attachments = fileList
    if (type === "check") {
      if (validatePaymentListCheck(newPayment, items, setIsErrorCheck)) {
        setIsClicked(true)
        const response = await createSeCheckPayment(newPayment, items)
        if (response.data) {
          toast.success(response.data.message, { style: toastStyle() })
          setTimeout(() => {
            navigate("/se/paysuppliers")
            refreshPage()
          }, 1000)
        } else {
          response.error?.response?.data?.messages.map((data) => {
            return toast.error(data)
          })
          setTimeout(() => {
            setIsClicked(false)
          }, 1000)
        }
      } else {
        toast.error("Please fill in all required fields", {
          style: toastStyle(),
        })
      }
    } else if (type === "cash") {
      if (validatePaymentListCash(newPayment, items, setIsError)) {
        setIsClicked(true)
        const response = await createSeCashPayment(newPayment, items)

        if (response.data) {
          toast.success(response.data.message, {
            style: toastStyle(),
          })
          setTimeout(() => {
            navigate("/se/paysuppliers")
          }, 1000)
        } else {
          response.error?.response?.data?.messages.map((data) => {
            return toast.error(data)
          })
          setTimeout(() => {
            setIsClicked(false)
          }, 1000)
        }
      } else {
        toast.error("Please fill in all required fields", {
          style: toastStyle(),
        })
      }
    } else if (type === "bank") {
      if (validatePaymentListBank(newPayment, items, setIsErrorBank)) {
        setIsClicked(true)
        const response = await createSeBankPayment(newPayment, items)
        if (response.data) {
          toast.success(response.data.message, {
            style: toastStyle(),
          })
          setTimeout(() => {
            navigate("/se/paysuppliers")
            // refreshPage();
          }, 1000)
        } else {
          response.error?.response?.data?.messages.map((data) => {
            return toast.error(data)
          })
          setTimeout(() => {
            setIsClicked(false)
          }, 1000)
        }
      } else {
        toast.error("Please fill in all required fields", {
          style: toastStyle(),
        })
      }
    } else if (type === "other" || type === "others") {
      if (validatePaymentListOthers(newPayment, items, setIsError)) {
        setIsClicked(true)
        const response = await createSeOtherPayment(
          newPayment,
          items,
          totalAmount
        )

        if (response.data) {
          toast.success(response.data.response, {
            style: toastStyle(),
          })
          setTimeout(() => {
            navigate("/se/paysuppliers")
          }, 1000)
        } else {
          response.error?.response?.data?.messages.map((data) => {
            return toast.error(data)
          })
          setTimeout(() => {
            setIsClicked(false)
          }, 1000)
        }
      } else {
        toast.error("Please fill in all required fields", {
          style: toastStyle(),
        })
      }
    }
  }

  const [addBankData, setAddBankData] = useState({
    bank_name: "",
    check_template_id: "",
  })

  const handleAddChange = (e) => {
    const { name, value } = e.target
    setAddBankData((prevState) => ({
      ...prevState,
      [name]: value,
    }))
  }

  async function addBank() {
    if (validateBanks(addBankData, setIsErrorAddBank)) {
      const response = await createBank(addBankData)

      if (response.data) {
        toast.success(response.data.message, {
          style: toastStyle(),
        })
      } else {
        response.error?.response?.data?.messages.map((data) => {
          return toast.error(data)
        })
      }
      setTimeout(() => refreshPage(), 1000)
    } else {
      toast.error("Please fill in all required fields", {
        style: toastStyle(),
      })
    }
  }

  /** POST API - EDIT EXISTING PAYMENT **/
  async function editPayment() {
    newPayment.attachments = fileList
    newPayment.prev_files = prevAttachments
    if (type === "check") {
      if (validatePaymentListCheck(newPayment, items, setIsErrorCheck)) {
        const response = await updateCheckPayment(newPayment, items, id)

        if (response.data) {
          toast.success(response.data.response, {
            style: toastStyle(),
          })
          setTimeout(() => {
            navigate("/se/paysuppliers")
          }, 1000)
        } else {
          response.error?.response?.data?.messages.map((data) => {
            return toast.error(data)
          })
          setIsClicked(false)
          setTimeout(() => {
            refreshPage()
          }, 1000)
        }
      } else {
        toast.error("Please fill in all required fields", {
          style: toastStyle(),
        })
      }
    } else if (type === "cash") {
      if (validatePaymentListCash(newPayment, items, setIsError)) {
        const response = await updateCashPayment(newPayment, items, id)
        if (response.data) {
          toast.success(response.data.response, {
            style: toastStyle(),
          })
          setTimeout(() => {
            navigate("/se/paysuppliers")
          }, 1000)
        } else {
          response.error?.response?.data?.messages.map((data) => {
            return toast.error(data)
          })
          setIsClicked(false)
          setTimeout(() => {
            // refreshPage()
          }, 1000)
        }
      } else {
        toast.error("Please fill in all required fields", {
          style: toastStyle(),
        })
      }
    } else if (type === "bank") {
      if (validatePaymentListBank(newPayment, items, setIsErrorBank)) {
        const response = await updateBankPayment(
          newPayment,
          items,
          transactionFee,
          id
        )

        if (response.data) {
          toast.success(response.data.response, {
            style: toastStyle(),
          })
          setTimeout(() => {
            navigate("/se/paysuppliers")
          }, 1000)
        } else {
          response.error?.response?.data?.messages.map((data) => {
            return toast.error(data)
          })
          setIsClicked(false)
          setTimeout(() => {
            refreshPage()
          }, 1000)
        }
      } else {
        toast.error("Please fill in all required fields", {
          style: toastStyle(),
        })
      }
    } else if (type === "other" || type === "others") {
      if (validatePaymentListOthers(newPayment, items, setIsError)) {
        const response = await updateOtherPayment(
          newPayment,
          items,
          id,
          totalAmount
        )
        if (response.data) {
          toast.success(response.data.response, {
            style: toastStyle(),
          })
          setTimeout(() => {
            navigate("/se/paysuppliers")
          }, 1000)
        } else {
          response.error?.response?.data?.messages.map((data) => {
            return toast.error(data)
          })
          setIsClicked(false)
          setTimeout(() => {
            refreshPage()
          }, 1000)
        }
      }
    }
  }

  function handleSubmit() {
    if (add) savePayment()
    if (edit) editPayment()
  }

  async function fetchSingleSuppliersPayment(id) {
    setIsChanged(true)
    if (type === "cash") {
      const cash = await getSingleCashSe(id)
      if (cash.data) {
        var data = cash.data.data[0]
        setPrevAttachments(data.supplies_receive_cash_slip_attachments)
        var dataEntries = data.supplies_receive_cash_entries
        if (data.supplier_id !== null) {
          fetchReceives({
            supplier_id: data.supplier_id,
            vendor_id: "",
          })
        } else {
          fetchReceives({
            vendor_id: data.vendor_id,
            supplier_id: "",
          })
        }
        setNewPayment({
          payment_date: data.payment_date,
          supplier_id: data.supplier_id,
          payee: data.payee,
          particulars: data.particulars,
          acknowledged_by: data.acknowledged_by,
        })
        var cashEntries = dataEntries.map((entry) => {
          var info = {}
          info.entry = {
            name: "receive_id",
            label: "Invoice No. " + entry.se_id + " - " + entry.amount,
            value: parseInt(entry.se_id),
          }
          info.amount = entry.amount
          info.invoice_date = formatDateNoTime(entry.added_on)
          info.withholding = parseFloat(entry.withholding_tax)
          info.other_fees = parseFloat(entry.service_fee_payment)
          info.subtotal =
            parseFloat(entry.amount) - parseFloat(entry.withholding_tax)
          info.grand_amount =
            parseFloat(entry.amount) +
            parseFloat(entry.service_fee_payment) -
            parseFloat(entry.withholding_tax)

          return info
        })
        setItems(cashEntries)
        setSupplierValue({
          name: "supplier_id",
          label: data.supplier_name,
          value: parseInt(data.supplier_id),
          payee: data.payee,
        })
      }
    } else if (type === "check") {
      const check = await getSingleCheckSe(id)
      if (check.data) {
        var data = check.data.data[0]
        var dataEntries = data.supplies_receive_check_entries
        setPrevAttachments(data.supplies_receive_check_slip_attachments)
        if (data.supplier_id !== null) {
          fetchReceives({
            supplier_id: data.supplier_id,
            vendor_id: "",
          })
        } else {
          fetchReceives({
            vendor_id: data.vendor_id,
            supplier_id: "",
          })
        }
        setNewPayment({
          supplier_id: data.supplier_id,
          bank_id: data.bank_id,
          bank_name: data.bank_name,
          check_no: data.check_no,
          check_date: data.check_date,
          payee: data.payee,
          particulars: data.particulars,
          acknowledged_by: data.acknowledged_by,
          issued_date: Moment(data.issued_date).format("YYYY-MM-DD"),
          sig_1: data.sig_1,
          sig_2: data.sig_2,
        })
        var checkEntries = dataEntries.map((entry) => {
          var info = {}
          info.entry = {
            name: "receive_id",
            label: "Invoice No. " + entry.se_id + " - " + entry.amount,
            value: parseInt(entry.se_id),
          }
          info.amount = entry.amount
          info.invoice_date = formatDateNoTime(entry.added_on)
          info.withholding = parseFloat(entry.withholding_tax)
          info.other_fees = parseFloat(entry.service_fee_payment)
          info.subtotal =
            parseFloat(entry.amount) - parseFloat(entry.withholding_tax)
          info.grand_amount =
            parseFloat(entry.amount) +
            parseFloat(entry.service_fee_payment) -
            parseFloat(entry.withholding_tax)

          return info
        })
        setItems(checkEntries)
        setSupplierValue({
          name: "supplier_id",
          label: data.supplier_name,
          value: parseInt(data.supplier_id),
          payee: data.payee,
        })
        setBankValue({
          name: "bank_id",
          label: data.bank_name,
          value: parseInt(data.bank_id),
        })
      }
    } else if (type === "bank") {
      const bank = await getSingleBankSe(id)
      if (bank.data) {
        var data = bank.data.data[0]
        setPrevAttachments(data.supplies_receive_bank_slip_attachments)
        var dataEntries = data.supplies_receive_bank_entries
        if (data.supplier_id !== null) {
          fetchReceives({
            supplier_id: data.supplier_id,
            vendor_id: "",
          })
        } else {
          fetchReceives({
            vendor_id: data.vendor_id,
            supplier_id: "",
          })
        }
        setNewPayment({
          payment_date: data.payment_date,
          transaction_fee: data.transaction_fee,
          reference_no: data.reference_no,
          amount: data.amount,
          payee: data.payee,
          particulars: data.particulars,
          acknowledged_by: data.acknowledged_by,
          supplier_id: data.supplier_id,

          bank_from: data.bank_from,
          from_account_no: data.from_account_no,
          from_account_name: data.from_account_name,

          bank_to: data.bank_to,
          to_account_no: data.to_account_no,
          to_account_name: data.to_account_name,
        })
        var bankEntries = dataEntries.map((entry) => {
          var info = {}
          info.entry = {
            name: "receive_id",
            label: "Invoice No. " + entry.se_id + " - " + entry.amount,
            value: parseInt(entry.se_id),
          }
          info.amount = entry.amount
          info.invoice_date = formatDateNoTime(entry.added_on)
          info.withholding = parseFloat(entry.withholding_tax)
          info.other_fees = parseFloat(entry.service_fee_payment)
          info.subtotal =
            parseFloat(entry.amount) - parseFloat(entry.withholding_tax)
          info.grand_amount =
            parseFloat(entry.amount) +
            parseFloat(entry.service_fee_payment) -
            parseFloat(entry.withholding_tax)

          return info
        })
        setItems(bankEntries)
        setSupplierValue({
          name: "supplier_id",
          label: data.supplier_name,
          value: parseInt(data.supplier_id),
          payee: data.payee,
        })
        setFromBankValue({
          name: "bank_from",
          label: data.bank_from_name,
          value: parseInt(data.bank_from),
        })
        setTransactionFee(data.transaction_fee)
        setGrandTotal(
          parseFloat(data.amount) + parseFloat(data.transaction_fee)
        )
      }
    } else if (type === "other" || type === "others") {
      const cash = await getSingleOtherSe(id)
      if (cash.data) {
        var data = cash.data.data[0]
        setPrevAttachments(data.supplies_receive_other_slip_attachments)
        var dataEntries = data.supplies_receive_other_entries
        if (data.supplier_id !== null) {
          fetchReceives({
            supplier_id: data.supplier_id,
            vendor_id: "",
          })
        } else {
          fetchReceives({
            vendor_id: data.vendor_id,
            supplier_id: "",
          })
        }
        setNewPayment({
          payment_date: data.payment_date,
          supplier_id: data.supplier_id,
          payee: data.payee,
          particulars: data.particulars,
          acknowledged_by: data.acknowledged_by,
        })
        var cashEntries = dataEntries.map((entry) => {
          var info = {}
          info.entry = {
            name: "receive_id",
            label: "Invoice No. " + entry.se_id + " - " + entry.amount,
            value: parseInt(entry.se_id),
          }
          info.amount = entry.amount
          info.invoice_date = formatDateNoTime(entry.added_on)
          info.withholding = parseFloat(entry.withholding_tax)
          info.other_fees = parseFloat(entry.service_fee_payment)
          info.subtotal =
            parseFloat(entry.amount) - parseFloat(entry.withholding_tax)
          info.grand_amount =
            parseFloat(entry.amount) +
            parseFloat(entry.service_fee_payment) -
            parseFloat(entry.withholding_tax)

          return info
        })
        setItems(cashEntries)
        setSupplierValue({
          name: "supplier_id",
          label: data.supplier_name,
          value: parseInt(data.supplier_id),
          payee: data.payee,
        })
      }
    }
    setTimeout(() => setIsChanged(false), 10)
  }

  async function fetchReceives(data) {
    const response = await getOpenSeReceives(data, "open")
    if (response.data) {
      if (response.data) {
        var data = response.data.data
        var clean = data.map((entry) => {
          var info = entry
          var labelKeyword =
            entry.invoice_no !== "" && entry.invoice_no !== null
              ? "Invoice No. " + entry.invoice_no
              : "DR No. " + entry.dr_no
          info.name = "se_ids"
          info.value = entry.id
          info.label =
            // "Invoice No. " +
            labelKeyword + " - " + entry.grand_total
          info.entry = {
            name: "se_ids",
            value: entry.id,
            label:
              // "Invoice No. " +
              labelKeyword + " - " + entry.grand_total,
          }
          info.invoice_date = entry.purchase_date
          info.amount = parseFloat(entry.discounted_subtotal_balance)
          info.other_fees = parseFloat(entry.service_fee_balance)
          //   info.withholding = entry.withholding_tax
          info.withholding_percentage = entry.withholding_percentage
            ? entry.withholding_percentage
            : 0
          info.vat_type = entry.vat_type

          // WITHHOLDING CAlCULATION
          const wth_percentage = parseFloat(info.withholding_percentage) / 100
          if (entry.vat_type === "VAT") {
            const vatableSales =
              parseFloat(entry.discounted_subtotal_balance) / 1.12
            info.withholding = parseFloat(
              vatableSales * wth_percentage
            ).toFixed(2)
          } else {
            info.withholding = 0
          }
          info.subtotal =
            parseFloat(entry.discounted_subtotal_balance) +
            parseFloat(entry.service_fee_balance) -
            parseFloat(info.withholding)
          return info
        })
        //
        setEntries(clean)
        setSelectedOptions(clean)
        setEntriesList(clean)
      } else {
        setEntries([])
      }
    } else {
      TokenExpiry(response)
      setEntries([])
    }
  }

  const [newEntry, setNewEntry] = useState({
    name: "",
    value: "",
    label: "",
    entry: {},
    invoice_date: "",
    amount: "",
  })

  async function fetchSingleReceive(receive_id) {
    const response = await getSingleSeReceive(receive_id)
    setNewEntry([])

    if (response.data) {
      var data = response.data.data[0]
      setNewEntry({
        name: "se_ids",
        value: data.id,
        label: "Invoice No. " + data.id + " - " + data.grand_total,
        entry: {
          name: "se_ids",
          value: data.id,
          label: "Invoice No. " + data.id + " - " + data.grand_total,
        },
        invoice_date: formatDateNoTime(data.purchase_date),
        amount: data.balance,
      })
      setEntries((prevItems) => [...prevItems, newEntry])
    }
  }

  async function handleAddSupplier() {
    const response = await createSupplier(supplierDetails)
    if (response.response) {
      toast.success(response.response.response, { style: toastStyle() })
      handleCloseAddSupplierModal()
    } else {
      toast.error("Error Creating New Supplier", { style: toastStyle() })
    }
  }

  useEffect(() => {
    if (edit) {
      fetchSingleSuppliersPayment(id)
    }
    fetchBanks()
    fetchEmployees()
  }, [])

  useEffect(() => {
    fetchSingleReceive(remove)
  }, [remove])

  useEffect(() => {
    var _total = 0
    var _subtotal = 0
    var _item_withholding = 0
    var _item_other_fees = 0
    for (var i = 0; i < items.length; i++) {
      _subtotal +=
        parseFloat(items[i].amount) - parseFloat(items[i].withholding) // amount - withholding per item
      _item_withholding += parseFloat(items[i].withholding) // withholding total
      _item_other_fees += parseFloat(items[i].other_fees) // other total
      _total += parseFloat(items[i].amount) // other total
    }

    var _grand_total =
      parseFloat(newPayment.total_amount) - _item_withholding + _item_other_fees

    setNewPayment((prevState) => ({
      ...prevState,
      total_amount: _total,
      subtotal: _subtotal,
      grand_total: _grand_total,
      withholding_tax_total: _item_withholding,
      total_others: _item_other_fees,
    }))
  }, [isChanged])

  //DISABLE SCROLL FUNCTION
  function limitScroll() {
    var numericInputs = document.querySelectorAll(".numeric-input")
    numericInputs.forEach(function (input) {
      input.addEventListener("wheel", function (e) {
        e.preventDefault()
      })
    })
  }
  limitScroll()

  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive)
          }}
          active={"SUPPLIES PAYMENTS"}
        />
      </div>
      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        <Row className="mb-4">
          <Col xs={12} lg={7}>
            <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2">
              {" "}
              PAY SUPPLIER ({type})
            </h1>
          </Col>
        </Row>

        <div className="edit-form">
          {type === "check" && (
            <Fragment>
              <Row className="mb-3">
                <Col xs={12} lg={12}>
                  <span className="nc-modal-custom-row uppercase">
                    Bank
                    <label className="badge-required">{` *`}</label>
                  </span>
                  <Select
                    name="bank_from"
                    className="react-select-container nc-modal-custom-row-grey"
                    classNamePrefix="react-select"
                    placeholder="Select Bank..."
                    value={bankValue}
                    options={banks}
                    onChange={(e) => handleSelectChange(e)}
                  />
                  <InputError
                    isValid={isErrorCheck.bank_id}
                    message={"Bank is required"}
                  />
                  <Row className="click-to-add-prompt f-right mb-0">
                    <Col>
                      <p className="add-supplier-prompt mb-0">
                        BANK NOT FOUND?{" "}
                        <a
                          className="add-supplier-label"
                          onClick={handleShowAddBankModal}
                        >
                          Click to add bank
                        </a>
                      </p>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row className="mb-3">
                <Col xs={12} lg={4}>
                  <span className="nc-modal-custom-row uppercase">
                    Check Date
                    <label className="badge-required">{` *`}</label>
                  </span>
                  <Form.Control
                    type="date"
                    name="check_date"
                    defaultValue={newPayment.check_date}
                    className="nc-modal-custom-row-grey"
                    onChange={(e) => handlePayChange(e)}
                  />
                  <InputError
                    isValid={isErrorCheck.check_date}
                    message={"Check date is required"}
                  />
                </Col>
                <Col xs={12} lg={4} className="mt-4 mt-lg-0">
                  <span className="nc-modal-custom-row uppercase">
                    Check No.
                    <label className="badge-required">{` *`}</label>
                  </span>
                  <Form.Control
                    type="text"
                    name="check_no"
                    className="nc-modal-custom-input form-control"
                    defaultValue={newPayment.check_no}
                    onChange={(e) => handlePayChange(e)}
                  />
                  <InputError
                    isValid={isErrorCheck.check_no}
                    message={"Check Number is required"}
                  />
                </Col>
                <Col xs={12} lg={4} className="mt-4 mt-lg-0">
                  <span className="nc-modal-custom-row uppercase">
                    Issue Date
                    <label className="badge-required">{` *`}</label>
                  </span>
                  <Form.Control
                    type="date"
                    name="issued_date"
                    defaultValue={newPayment.issued_date}
                    className="nc-modal-custom-row-grey"
                    onChange={(e) => handlePayChange(e)}
                  />
                  <InputError
                    isValid={isErrorCheck.issued_date}
                    message={"Issued Date is required"}
                  />
                </Col>
              </Row>
              <Row className="mb-3">
                <Col xs={12} lg={6}>
                  <span className="nc-modal-custom-row uppercase">
                    Supplier Name
                    <label className="badge-required">{` *`}</label>
                  </span>
                  <SearchBox
                    showSearch
                    value={newPayment.supplier_id_value}
                    placeholder={"Search Supplier..."}
                    className="react-select-container w-100"
                    dropdownClassName="z-large antdesign-custom-dropdown"
                    style={antdesignSelectStyle}
                    defaultActiveFirstOption={false}
                    suffixIcon={null}
                    filterOption={false}
                    onSearch={handleSearchSupplier}
                    onChange={(e) => handleSelectChange(e, "supplier_id")}
                    notFoundContent={null}
                    options={(suppliers || []).map((d) => ({
                      value: d.value,
                      label: d.label,
                    }))}
                  />
                  <InputError
                    isValid={isErrorCheck.supplier_id}
                    message={"Supplier is required"}
                  />
                  <Row className="click-to-add-prompt f-right">
                    <p className="add-supplier-prompt">
                      SUPPLIER NOT FOUND?{" "}
                      <a
                        className="add-supplier-label"
                        onClick={handleShowAddSupplierModal}
                      >
                        Click to add supplier
                      </a>
                    </p>
                  </Row>
                </Col>
                <Col xs={12} lg={6}>
                  <span className="nc-modal-custom-row uppercase">
                    Payee
                    <label className="badge-required">{` *`}</label>
                  </span>
                  <Form.Control
                    type="text"
                    name="payee"
                    defaultValue={newPayment.payee}
                    className="nc-modal-custom-input form-control"
                    onChange={(e) => handlePayChange(e)}
                  />
                  <InputError
                    isValid={isErrorCheck.payee}
                    message={"Payee is required"}
                  />
                </Col>
              </Row>
              <Row>
                <Col xs={12} lg={6}>
                  <span className="nc-modal-custom-row uppercase">
                    Acknowledged By
                    <label className="badge-required">{` *`}</label>
                  </span>
                  <Select
                    className="react-select-container"
                    classNamePrefix="react-select"
                    placeholder="Select employee..."
                    value={employeeValue}
                    options={employees}
                    onChange={(e) => handleSelectChange(e)}
                  />
                  <InputError
                    isValid={isErrorCheck.acknowledged_by}
                    message={"Acknowledge by is required"}
                  />
                </Col>
                <Col xs={12} lg={6} className="mt-4 mt-lg-0">
                  <span className="nc-modal-custom-row uppercase">
                    Remarks
                    <span className="edit-optional px-2">(Optional)</span>
                  </span>
                  <Form.Control
                    type="text"
                    name="particulars"
                    className="nc-modal-custom-input form-control"
                    defaultValue={newPayment.particulars}
                    onChange={(e) => handlePayChange(e)}
                  />
                </Col>
              </Row>
            </Fragment>
          )}
          {type === "cash" && (
            <Fragment>
              <Row className="mb-3">
                <Col xs={12} lg={8}>
                  <span className="nc-modal-custom-row uppercase">
                    Supplier Name
                    <label className="badge-required">{` *`}</label>
                  </span>
                  <SearchBox
                    showSearch
                    value={newPayment.supplier_id_value}
                    placeholder={"Search Supplier..."}
                    className="react-select-container w-100"
                    dropdownClassName="z-large antdesign-custom-dropdown"
                    style={antdesignSelectStyle}
                    defaultActiveFirstOption={false}
                    suffixIcon={null}
                    filterOption={false}
                    onSearch={handleSearchSupplier}
                    onChange={(e) => handleSelectChange(e, "supplier_id")}
                    notFoundContent={null}
                    options={(suppliers || []).map((d) => ({
                      value: d.value,
                      label: d.label,
                    }))}
                  />
                  <InputError
                    isValid={isError.supplier_id}
                    message={"Supplier is required"}
                  />
                  <Row className="click-to-add-prompt f-right">
                    <p className="add-supplier-prompt">
                      SUPPLIER NOT FOUND?{" "}
                      <a
                        className="add-supplier-label"
                        onClick={handleShowAddSupplierModal}
                      >
                        Click to add supplier
                      </a>
                    </p>
                  </Row>
                </Col>
                <Col xs={12} lg={4}>
                  <span className="nc-modal-custom-row uppercase">
                    Payment Date
                    <label className="badge-required">{` *`}</label>
                  </span>
                  <Form.Control
                    type="date"
                    name="payment_date"
                    defaultValue={newPayment.payment_date}
                    className="nc-modal-custom-row-grey"
                    onChange={(e) => handlePayChange(e)}
                  />
                  <InputError
                    isValid={isError.payment_date}
                    message={"Payment Date is required"}
                  />
                </Col>
              </Row>
              <Row className="mb-3">
                <Col xs={12} lg={6}>
                  <span className="nc-modal-custom-row uppercase">
                    Payee
                    <label className="badge-required">{` *`}</label>
                  </span>
                  <Form.Control
                    type="text"
                    name="payee"
                    className="nc-modal-custom-input form-control"
                    defaultValue={newPayment.payee}
                    onChange={(e) => handlePayChange(e)}
                  />
                  <InputError
                    isValid={isError.payee}
                    message={"Payee is required"}
                  />
                </Col>
                <Col xs={12} lg={6} className="mt-4 mt-lg-0">
                  <span className="nc-modal-custom-row uppercase">
                    Acknowledged by
                    <label className="badge-required">{` *`}</label>
                  </span>
                  <Select
                    className="react-select-container"
                    classNamePrefix="react-select"
                    placeholder="Select employee..."
                    value={employeeValue}
                    options={employees}
                    onChange={(e) => handleSelectChange(e)}
                  />
                  <InputError
                    isValid={isError.acknowledged_by}
                    message={"Acknowledge by is required"}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <span className="nc-modal-custom-row uppercase">
                    Remarks
                    <span className="edit-optional px-2">(Optional)</span>
                  </span>
                  <Form.Control
                    as="textarea"
                    name="particulars"
                    className="nc-modal-custom-input form-control"
                    defaultValue={newPayment.particulars}
                    onChange={(e) => handlePayChange(e)}
                  />
                </Col>
              </Row>
            </Fragment>
          )}
          {type === "bank" && (
            <Fragment>
              <Row className="mb-3">
                <Col xs={12} lg={4}>
                  <span className="nc-modal-custom-row uppercase">
                    From Bank
                    <label className="badge-required">{` *`}</label>
                  </span>
                  <Select
                    name="bank_from"
                    className="react-select-container"
                    classNamePrefix="react-select"
                    value={fromBankValue}
                    placeholder="Select Bank..."
                    options={fromBanks}
                    onChange={(e) => handleSelectChange(e)}
                  />
                  <InputError
                    isValid={isErrorBank.bank_from}
                    message={"Bank is required"}
                  />
                </Col>
                <Col xs={12} lg={4} className="mt-4 mt-lg-0">
                  <span className="nc-modal-custom-row uppercase">
                    Payment Date
                    <label className="badge-required">{` *`}</label>
                  </span>
                  <Form.Control
                    type="date"
                    name="payment_date"
                    defaultValue={newPayment.payment_date}
                    className="nc-modal-custom-row-grey"
                    onChange={(e) => handlePayChange(e)}
                  />
                  <InputError
                    isValid={isErrorBank.payment_date}
                    message={"Payment Date is required"}
                  />
                </Col>
                <Col xs={12} lg={4} className="mt-4 mt-lg-0">
                  <span className="nc-modal-custom-row uppercase">
                    Reference No.
                    <label className="badge-required">{` *`}</label>
                  </span>
                  <Form.Control
                    type="text"
                    name="reference_no"
                    defaultValue={newPayment.reference_no}
                    className="nc-modal-custom-input form-control"
                    onChange={(e) => handlePayChange(e)}
                  />
                  <InputError
                    isValid={isErrorBank.reference_no}
                    message={"Reference number is required"}
                  />
                </Col>
              </Row>
              <Row className="mb-3">
                <Col xs={12} lg={6}>
                  <span className="nc-modal-custom-row uppercase">
                    Account Number
                    <label className="badge-required">{` *`}</label>
                  </span>
                  <Form.Control
                    type="text"
                    name="from_account_no"
                    className="nc-modal-custom-input form-control"
                    defaultValue={newPayment.from_account_no}
                    onChange={(e) => handlePayChange(e)}
                  />
                  <InputError
                    isValid={isErrorBank.from_account_no}
                    message={"Account number is required"}
                  />
                </Col>
                <Col xs={12} lg={6} className="mt-4 mt-lg-0">
                  <span className="nc-modal-custom-row uppercase">
                    Account Name
                    <label className="badge-required">{` *`}</label>
                  </span>
                  <Form.Control
                    type="text"
                    name="from_account_name"
                    className="nc-modal-custom-input form-control"
                    defaultValue={newPayment.from_account_name}
                    onChange={(e) => handlePayChange(e)}
                  />
                  <InputError
                    isValid={isErrorBank.from_account_name}
                    message={"Account name is required"}
                  />
                </Col>
              </Row>
              <Row className="mb-3">
                <Col xs={12} lg={6}>
                  <span className="nc-modal-custom-row uppercase">
                    Supplier Name
                    <label className="badge-required">{` *`}</label>
                  </span>
                  <SearchBox
                    showSearch
                    value={newPayment.supplier_id_value}
                    placeholder={"Search Supplier..."}
                    className="react-select-container w-100"
                    dropdownClassName="z-large antdesign-custom-dropdown"
                    style={antdesignSelectStyle}
                    defaultActiveFirstOption={false}
                    suffixIcon={null}
                    filterOption={false}
                    onSearch={handleSearchSupplier}
                    onChange={(e) => handleSelectChange(e, "supplier_id")}
                    notFoundContent={null}
                    options={(suppliers || []).map((d) => ({
                      value: d.value,
                      label: d.label,
                    }))}
                  />
                  <InputError
                    isValid={isErrorBank.supplier_id}
                    message={"Supplier is required"}
                  />
                  <Row className="click-to-add-prompt f-right">
                    <p className="add-supplier-prompt">
                      SUPPLIER NOT FOUND?{" "}
                      <a
                        className="add-supplier-label"
                        onClick={handleShowAddSupplierModal}
                      >
                        Click to add supplier
                      </a>
                    </p>
                  </Row>
                </Col>
                <Col xs={12} lg={6}>
                  <span className="nc-modal-custom-row uppercase">
                    Payee
                    <label className="badge-required">{` *`}</label>
                  </span>
                  <Form.Control
                    type="text"
                    name="payee"
                    className="nc-modal-custom-input form-control"
                    defaultValue={newPayment.payee}
                    onChange={(e) => handlePayChange(e)}
                  />
                  <InputError
                    isValid={isErrorBank.payee}
                    message={"Payee is required"}
                  />
                </Col>
              </Row>
              <Row className="mb-3">
                <Col xs={12} lg={4}>
                  <span className="nc-modal-custom-row uppercase">
                    To Bank
                    <label className="badge-required">{` *`}</label>
                  </span>
                  <Form.Control
                    type="text"
                    name="bank_to"
                    className="nc-modal-custom-input form-control"
                    defaultValue={newPayment.bank_to}
                    onChange={(e) => handlePayChange(e)}
                  />
                  {/* <Select
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        placeholder="Select Bank..."
                                        value={toBankValue}
                                        options={toBanks}
                                        onChange={(e) => handleSelectChange(e)}
                                    /> */}
                  <InputError
                    isValid={isErrorBank.bank_to}
                    message={"Bank is required"}
                  />
                </Col>
                <Col xs={12} lg={4} className="mt-4 mt-lg-0">
                  <span className="nc-modal-custom-row uppercase">
                    Account Number
                    <label className="badge-required">{` *`}</label>
                  </span>
                  <Form.Control
                    type="text"
                    name="to_account_no"
                    className="nc-modal-custom-input form-control"
                    defaultValue={newPayment.to_account_no}
                    onChange={(e) => handlePayChange(e)}
                  />
                  <InputError
                    isValid={isErrorBank.to_account_no}
                    message={"Account number is required"}
                  />
                </Col>
                <Col xs={12} lg={4} className="mt-4 mt-lg-0">
                  <span className="nc-modal-custom-row uppercase">
                    Account Name
                    <label className="badge-required">{` *`}</label>
                  </span>
                  <Form.Control
                    type="text"
                    name="to_account_name"
                    className="nc-modal-custom-input form-control"
                    defaultValue={newPayment.to_account_name}
                    onChange={(e) => handlePayChange(e)}
                  />
                  <InputError
                    isValid={isErrorBank.to_account_name}
                    message={"Account name is required"}
                  />
                </Col>
              </Row>
              <Row>
                <Col xs={12} lg={6}>
                  <span className="nc-modal-custom-row uppercase">
                    Acknowledged By
                    <label className="badge-required">{` *`}</label>
                  </span>
                  <Select
                    className="react-select-container"
                    classNamePrefix="react-select"
                    placeholder="Select employee..."
                    value={employeeValue}
                    options={employees}
                    onChange={(e) => handleSelectChange(e)}
                  />
                  <InputError
                    isValid={isErrorBank.acknowledged_by}
                    message={"Acknowledge by is required"}
                  />
                </Col>
                <Col xs={12} lg={6} className="mt-4 mt-lg-0">
                  <span className="nc-modal-custom-row uppercase">
                    Remarks
                    <span className="edit-optional px-2">(Optional)</span>
                  </span>
                  <Form.Control
                    type="text"
                    name="particulars"
                    className="nc-modal-custom-input form-control"
                    defaultValue={newPayment.particulars}
                    onChange={(e) => handlePayChange(e)}
                  />
                </Col>
              </Row>
            </Fragment>
          )}
          {(type === "other" || type === "others") && (
            <Fragment>
              <Row className="mb-3">
                <Col xs={12} lg={8}>
                  <span className="nc-modal-custom-row uppercase">
                    Supplier Name
                    <label className="badge-required">{` *`}</label>
                  </span>
                  <SearchBox
                    showSearch
                    value={newPayment.supplier_id_value}
                    placeholder={"Search Supplier..."}
                    className="react-select-container w-100"
                    dropdownClassName="z-large antdesign-custom-dropdown"
                    style={antdesignSelectStyle}
                    defaultActiveFirstOption={false}
                    suffixIcon={null}
                    filterOption={false}
                    onSearch={handleSearchSupplier}
                    onChange={(e) => handleSelectChange(e, "supplier_id")}
                    notFoundContent={null}
                    options={(suppliers || []).map((d) => ({
                      value: d.value,
                      label: d.label,
                    }))}
                  />
                  <InputError
                    isValid={isError.supplier_id}
                    message={"Supplier is required"}
                  />
                  <Row className="click-to-add-prompt f-right">
                    <p className="add-supplier-prompt">
                      SUPPLIER NOT FOUND?{" "}
                      <a
                        className="add-supplier-label"
                        onClick={handleShowAddSupplierModal}
                      >
                        Click to add supplier
                      </a>
                    </p>
                  </Row>
                </Col>
                <Col xs={12} lg={4}>
                  <span className="nc-modal-custom-row uppercase">
                    Payment Date
                    <label className="badge-required">{` *`}</label>
                  </span>
                  <Form.Control
                    type="date"
                    name="payment_date"
                    defaultValue={newPayment.payment_date}
                    className="nc-modal-custom-row-grey"
                    onChange={(e) => handlePayChange(e)}
                  />
                  <InputError
                    isValid={isError.payment_date}
                    message={"Payment Date is required"}
                  />
                </Col>
              </Row>
              <Row className="mb-3">
                <Col xs={12} lg={6}>
                  <span className="nc-modal-custom-row uppercase">
                    Type
                    <label className="badge-required">{` *`}</label>
                  </span>
                  <Form.Control
                    type="text"
                    name="transaction_type"
                    defaultValue={newPayment.transaction_type}
                    className="nc-modal-custom-row-grey"
                    onChange={(e) => handlePayChange(e)}
                  />
                  <InputError
                    isValid={isError.transaction_type}
                    message={"Type is required"}
                  />
                </Col>
                <Col xs={12} lg={6} className="mt-4 mt-lg-0">
                  <span className="nc-modal-custom-row uppercase">
                    Reference No.
                    <label className="badge-required">{` *`}</label>
                  </span>
                  <Form.Control
                    type="text"
                    name="transaction_no"
                    defaultValue={newPayment.transaction_no}
                    className="nc-modal-custom-row-grey"
                    onChange={(e) => handlePayChange(e)}
                  />
                  <InputError
                    isValid={isError.transaction_no}
                    message={"Reference No. is required"}
                  />
                </Col>
              </Row>
              <Row className="mb-3">
                <Col xs={12} lg={6}>
                  <span className="nc-modal-custom-row uppercase">
                    Payee
                    <label className="badge-required">{` *`}</label>
                  </span>
                  <Form.Control
                    type="text"
                    name="payee"
                    className="nc-modal-custom-input form-control"
                    defaultValue={newPayment.payee}
                    onChange={(e) => handlePayChange(e)}
                  />
                  <InputError
                    isValid={isError.payee}
                    message={"Payee is required"}
                  />
                </Col>
                <Col xs={12} lg={6} className="mt-4 mt-lg-0">
                  <span className="nc-modal-custom-row uppercase">
                    Acknowledged by
                    <label className="badge-required">{` *`}</label>
                  </span>
                  <Select
                    className="react-select-container"
                    classNamePrefix="react-select"
                    placeholder="Select employee..."
                    value={employeeValue}
                    options={employees}
                    onChange={(e) => handleSelectChange(e)}
                  />
                  <InputError
                    isValid={isError.acknowledged_by}
                    message={"Acknowledge by is required"}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <span className="nc-modal-custom-row uppercase">
                    Remarks
                    <span className="edit-optional px-2">(Optional)</span>
                  </span>
                  <Form.Control
                    as="textarea"
                    name="particulars"
                    className="nc-modal-custom-input form-control"
                    defaultValue={newPayment.particulars}
                    onChange={(e) => handlePayChange(e)}
                  />
                </Col>
              </Row>
            </Fragment>
          )}

          <div className="mt-3 pt-3 d-flex flex-column">
            <span className="nc-modal-custom-row mb-2 uppercase">
              Applied to following invoices
            </span>
            <Container fluid className="edit-purchased-items">
              {items.length === 0 ? (
                <div className="entries-not-found">
                  {add && "You haven't added any invoices yet."}
                  {edit && "Entries not found."}
                </div>
              ) : (
                <>{renderTable()}</>
              )}
            </Container>
            <Row className="pt-3 PO-add-item">
              <InputError
                isValid={isError.list}
                message={
                  "There must be at least one ingredient for this product!"
                }
              />
              <InputError
                isValid={isErrorCheck.list}
                message={
                  "There must be at least one ingredient for this product!"
                }
              />
              <InputError
                isValid={isErrorBank.list}
                message={
                  "There must be at least one ingredient for this product!"
                }
              />
            </Row>

            <Row className="my-2 align-right pb-2 align-items-start">
              <Col className="pt-3 PO-add-item">
                <Button type="button" onClick={() => AddItem()}>
                  Add Invoice
                </Button>
              </Col>
              {items.length !== 0 && (
                <>
                  <Col className="pt-3">
                    <Row className="mb-3">
                      <Col xs={4} className="text-end print-table-footer-label">
                        TOTAL AMOUNT
                      </Col>
                      <Col
                        xs={4}
                        className="text-end print-table-footer-data ps-4"
                      >
                        {numberFormat(newPayment.total_amount)}
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col xs={4} className="text-end print-table-footer-label">
                        TOTAL WHT
                      </Col>
                      <Col
                        xs={4}
                        className="text-end print-table-footer-data ps-4"
                      >
                        {numberFormat(newPayment.withholding_tax_total)}
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col xs={4} className="text-end print-table-footer-label">
                        SUBTOTAL
                      </Col>
                      <Col
                        xs={4}
                        className="text-end print-table-footer-data ps-4"
                      >
                        {numberFormat(newPayment.subtotal)}
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col xs={4} className="text-end print-table-footer-label">
                        TOTAL OTHERS
                      </Col>
                      <Col
                        xs={4}
                        className="text-end print-table-footer-data ps-4"
                      >
                        {numberFormat(newPayment.total_others)}
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col
                        xs={4}
                        className="bold text-end print-table-footer-label"
                      >
                        GRAND TOTAL
                      </Col>
                      <Col
                        xs={4}
                        className="bold text-end print-table-footer-data ps-4"
                      >
                        {newPayment.grand_total
                          ? numberFormat(newPayment.grand_total)
                          : "0.00"}
                      </Col>
                    </Row>
                  </Col>
                </>
              )}
            </Row>
            {edit && (
              <>
                <div className="mt-4 noPrint mx-3">
                  <Row className="review-data mb-2">FILE ATTACHMENTS</Row>
                  <Row className="">
                    {prevAttachments &&
                      prevAttachments.map((attachment) => (
                        <Col
                          xs={1}
                          onClick={() => {
                            setPreviewFile(attachment.file_url)
                            setPreview(true)
                          }}
                          className="cursor-pointer preview-container"
                        >
                          <img
                            src={attachment.file_url}
                            className="img-preview"
                          />
                        </Col>
                      ))}
                    {!prevAttachments ||
                      (prevAttachments.length === 0 && (
                        <Col xs={1}>
                          <div className="no-data-cont d-flex justify-content-left preview-container">
                            <img
                              src={noDataImg}
                              alt="no data found"
                              className="img-preview"
                            />
                          </div>
                        </Col>
                      ))}
                  </Row>
                </div>
              </>
            )}
            <Row className="mt-4 mb-2">
              <Col>
                <Dragger
                  fileList={fileList}
                  onRemove={handleRemove}
                  beforeUpload={handleBeforeUpload}
                  multiple={false}
                  listType="picture"
                  progress={{ showInfo: true }}
                >
                  <img src={upload} className="cursor-pointer" />
                  <p className="ant-upload-text">
                    Click or drag file to this area to upload
                  </p>
                </Dragger>
              </Col>
            </Row>
          </div>
          <div className="d-flex justify-content-end pt-5 pb-3">
            <button
              type="button"
              className="button-secondary me-3"
              onClick={() => navigate(-1)}
            >
              Cancel
            </button>
            {isClicked ? (
              <div className="button-primary me-3 d-flex justify-content-center">
                <ReactLoading
                  type="bubbles"
                  color="#FFFFFF"
                  height={50}
                  width={50}
                />
              </div>
            ) : (
              <button
                type="button"
                className="button-primary"
                onClick={handleSubmit}
              >
                Save
              </button>
            )}
          </div>
        </div>
      </div>
      <AddModal
        title="BANK"
        size="lg"
        type="bank"
        show={showAddBankModal}
        onHide={handleCloseAddBankModal}
        onSave={() => addBank()}
      >
        <div className="mt-3 edit-form ">
          <Row className="nc-modal-custom-row mt-0">
            <Col>
              BANK NAME
              <span className="required-icon">*</span>
              <Form.Control
                type="text"
                name="bank_name"
                value={addBankData.bank_name}
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
              <InputError
                isValid={isErrorAddBank.bank_name}
                message={"Bank name is required"}
              />
            </Col>
            <Col>
              Print Template
              <span className="required-icon">*</span>
              <select
                className="nc-modal-custom-select"
                name="check_template_id"
                value={addBankData.check_template_id}
                onChange={(e) => handleAddChange(e)}
              >
                <option selected value={"select"}>
                  Select
                </option>
                {checkTemplateData.map((data) => {
                  return <option value={data.id}>{data.name}</option>
                })}
              </select>
              <InputError
                isValid={isErrorAddBank.check_template_id}
                message={"Bank name is required"}
              />
            </Col>
          </Row>
        </div>
      </AddModal>
      <AddModal
        title="SUPPLIER"
        show={showAddSupplierModal}
        onHide={handleCloseAddSupplierModal}
        onSave={handleAddSupplier}
      >
        <div className="mt-3 edit-form">
          <Row className="nc-modal-custom-row mt-0">
            <Col>
              BIR NAME <label className="badge-required">{` *`}</label>
              <Form.Control
                type="text"
                name="bir_name"
                value={supplierDetails.bir_name}
                className="nc-modal-custom-input"
                onChange={(e) =>
                  setSupplierDetails({
                    ...supplierDetails,
                    [e.target.name]: e.target.value,
                  })
                }
                required
              />
            </Col>
            <Col>
              TRADE NAME <label className="badge-required">{` *`}</label>
              <Form.Control
                type="text"
                name="trade_name"
                value={supplierDetails.trade_name}
                className="nc-modal-custom-input"
                onChange={(e) =>
                  setSupplierDetails({
                    ...supplierDetails,
                    [e.target.name]: e.target.value,
                  })
                }
                required
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row">
            <Col>
              BIR-REGISTERED ADDRESS
              <Form.Control
                type="text"
                name="bir_address"
                value={supplierDetails.bir_address}
                className="nc-modal-custom-input"
                onChange={(e) =>
                  setSupplierDetails({
                    ...supplierDetails,
                    [e.target.name]: e.target.value,
                  })
                }
                required
              />
            </Col>
            <Col>
              TRADE ADDRESS <label className="badge-required">{` *`}</label>
              <Form.Control
                type="text"
                name="trade_address"
                value={supplierDetails.trade_address}
                className="nc-modal-custom-input"
                onChange={(e) =>
                  setSupplierDetails({
                    ...supplierDetails,
                    [e.target.name]: e.target.value,
                  })
                }
                required
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row">
            <Col>
              TIN NUMBER <label className="badge-required">{` *`}</label>
              <Form.Control
                type="text"
                name="tin"
                value={supplierDetails.tin}
                className="nc-modal-custom-input"
                onChange={(e) =>
                  setSupplierDetails({
                    ...supplierDetails,
                    [e.target.name]: e.target.value,
                  })
                }
                required
              />
            </Col>
            <Col>
              BIR NUMBER
              <Form.Control
                type="text"
                name="bir_number"
                className="nc-modal-custom-input"
                onChange={(e) =>
                  setSupplierDetails({
                    ...supplierDetails,
                    [e.target.name]: e.target.value,
                  })
                }
                required
              />
            </Col>
            <Col xl={3}>
              TERM (DAYS) <label className="badge-required">{` *`}</label>
              <Form.Control
                type="text"
                name="terms"
                value={supplierDetails.terms}
                className="nc-modal-custom-input"
                onChange={(e) =>
                  setSupplierDetails({
                    ...supplierDetails,
                    [e.target.name]: e.target.value,
                  })
                }
                required
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row">
            <Col xl={4}>
              CONTACT PERSON <label className="badge-required">{` *`}</label>
              <Form.Control
                type="text"
                name="contact_person"
                value={supplierDetails.contact_person}
                className="nc-modal-custom-input"
                onChange={(e) =>
                  setSupplierDetails({
                    ...supplierDetails,
                    [e.target.name]: e.target.value,
                  })
                }
                required
              />
            </Col>
            <Col xl={4}>
              PHONE NUMBER <label className="badge-required">{` *`}</label>
              <Form.Control
                type="text"
                name="phone_no"
                value={supplierDetails.phone_no}
                className="nc-modal-custom-input"
                onChange={(e) =>
                  setSupplierDetails({
                    ...supplierDetails,
                    [e.target.name]: e.target.value,
                  })
                }
                required
              />
            </Col>
            <Col>
              PAYEE <label className="badge-required">{` *`}</label>
              <Form.Control
                type="email"
                name="payee"
                value={supplierDetails.payee}
                className="nc-modal-custom-input"
                onChange={(e) =>
                  setSupplierDetails({
                    ...supplierDetails,
                    [e.target.name]: e.target.value,
                  })
                }
                required
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row">
            <Col>
              PRIMARY BANK NAME
              <Form.Control
                type="text"
                name="bank_primary"
                value={supplierDetails.bank_primary}
                className="nc-modal-custom-input"
                onChange={(e) =>
                  setSupplierDetails({
                    ...supplierDetails,
                    [e.target.name]: e.target.value,
                  })
                }
                required
              />
            </Col>
            <Col>
              PRIMARY ACCOUNT NO.
              <Form.Control
                type="number"
                name="primary_account_no"
                className="nc-modal-custom-input hide-spinner numeric-input"
                onChange={(e) =>
                  setSupplierDetails({
                    ...supplierDetails,
                    [e.target.name]: e.target.value,
                  })
                }
                required
              />
            </Col>
            <Col xl={5}>
              PRIMARY ACCOUNT NAME
              <Form.Control
                type="text"
                name="primary_account_name"
                className="nc-modal-custom-input"
                onChange={(e) =>
                  setSupplierDetails({
                    ...supplierDetails,
                    [e.target.name]: e.target.value,
                  })
                }
                required
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row">
            <Col>
              ALTERNATE BANK NAME
              <Form.Control
                type="text"
                name="bank_alternate"
                value={supplierDetails.bank_alternate}
                className="nc-modal-custom-input"
                onChange={(e) =>
                  setSupplierDetails({
                    ...supplierDetails,
                    [e.target.name]: e.target.value,
                  })
                }
                required
              />
            </Col>
            <Col>
              ALTERNATE ACCOUNT NO.
              <Form.Control
                type="number"
                name="alternate_account_no"
                className="nc-modal-custom-input"
                onChange={(e) =>
                  setSupplierDetails({
                    ...supplierDetails,
                    [e.target.name]: e.target.value,
                  })
                }
                required
              />
            </Col>
            <Col xl={5}>
              ALTERNATE ACCOUNT NAME
              <Form.Control
                type="text"
                name="alternate_account_name"
                className="nc-modal-custom-input"
                onChange={(e) =>
                  setSupplierDetails({
                    ...supplierDetails,
                    [e.target.name]: e.target.value,
                  })
                }
                required
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row">
            <Col xl={4}>
              COMPANY EMAIL <label className="badge-required">{` *`}</label>
              <Form.Control
                type="email"
                name="email"
                value={supplierDetails.email}
                className="nc-modal-custom-input"
                onChange={(e) =>
                  setSupplierDetails({
                    ...supplierDetails,
                    [e.target.name]: e.target.value,
                  })
                }
                required
              />
            </Col>
          </Row>
          <Row className="m-divider mt-3 mb-3"></Row>
          <Row className="nc-modal-custom-row">
            <Col>
              REQUIREMENTS
              <Form.Control
                type="file"
                multiple
                name="requirements"
                className="nc-modal-custom-input"
                onChange={(e) =>
                  setSupplierDetails({
                    ...supplierDetails,
                    [e.target.name]: e.target.value,
                  })
                }
                required
              />
            </Col>
          </Row>
        </div>
      </AddModal>
      <Modal
        open={preview}
        title={""}
        footer={null}
        onCancel={() => setPreview(false)}
      >
        <Row className="justify-content-center">
          <img
            alt="example"
            style={{
              width: "100%",
            }}
            src={previewFile}
          />
          <div className="mt-2 d-flex justify-content-center">
            <img
              src={trash}
              alt="trash"
              onClick={() => handleRemoveItemAttachment(previewFile)}
              className="cursor-pointer"
            />
          </div>
        </Row>
      </Modal>
      <FileExceedModal
        show={showFileExceedModal}
        onHide={() => setShowFileExceedModal(false)}
        size="2MB"
      />
      <Footer />
    </div>
  )
}

FormPaySupplier.defaultProps = {
  add: false,
  edit: false,
}

export default FormPaySupplier
